export default "__VITE_ASSET__451f8041__"